import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FooterWrapper } from "./style";
import {
  ArrowForwardWhite,
  LogoVyga
} from "../../shared/icons";
import { HeaderLogo } from "../header/style";
import { screenSizes } from "../../styles/theme";

const FooterButton = styled.a`
  border: 2px solid rgba(255, 255, 255, 0.2);
  max-width: 329px !important;
  width: 329px !important;
  @media (max-width: ${screenSizes.L}px) {
    max-width: 100% !important;
    width: 100% !important;
    margin-block: 10px;
  }
  padding: 16px 24px;
  gap: 24px;
  border-radius: 80px;
  opacity: 0px;
  font-family: Manrope;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  background: transparent;
  color: #fff;
  display: flex;
  gap: 30px;
  align-items: center;
  cursor: pointer;
  &:hover {
    border: 2px solid #ffffff20;
    background: #ffffff20;
  }
`;

const TouchButton = styled.button`
  max-width: 180px;
  width: 100%;
  height: 180px;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  background: transparent;
  border: 2px solid white;
`;

const Footer = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 850;

  return (
    <FooterWrapper>
      <>
        <h2>Shaping the future<br/>
        <i>powered by AI</i></h2>
        <div className="footer_content_btn">
          <div className="redirect_btn">
            <p>
            Stay informed on VYGA's latest advancements in AI x Productivity Growth x Efficient Governance –{!isMobile && <br/> } join our community for exclusive insights,
            updates, and opportunities to drive the next wave of innovation.
            </p>
            <div className="btn_wrapper">
              <FooterButton href="mailto:contact@vyga.co" >
                contact@vyga.co
                <ArrowForwardWhite />
              </FooterButton>
              <FooterButton onClick={(e) => {
                e.preventDefault();
                navigate("/roadmap");
              }}>
                Go to Roadmap
                <ArrowForwardWhite />
              </FooterButton>
            </div>
          </div>
          {!isMobile && (
            <div className="footer_touch_btn">
              <a href="mailto:contact@vyga.co" style={{ textDecoration: 'none' }}>
                <TouchButton>Get in touch</TouchButton>
              </a>
            </div>
          )}
        </div>
        <HeaderLogo
          src={LogoVyga}
          alt="vygalogo"
          onClick={() => navigate("/")}
        />
        <div className="bottom_footer">
          <ul>
            <li>VYGA — ©2025 All rights reserved</li>
            <li>
              Check our Social Media —<span></span>
              <a
              target="_blank" rel="noopener noreferrer" href="https://www.twitter.com/"
              >X</a>
              <span>{"|"}</span>
              <a
              target="_blank" rel="noopener noreferrer" href="https://web.telegram.org/"
              >Telegram</a>
              <span>{"|"}</span>
              <a
              target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/"
              >Linkedin</a>
            </li>
          </ul>
        </div>
      </>
    </FooterWrapper>
  );
};

export default Footer;
